export default "__VITE_ASSET__Bgl_WPSU__"